import { Roles } from '../constants.js';

export default {
    path: '/app',
    component: () => import('@/views/layouts/AppLayout.vue'),
    meta: { requiresAuth: true, role: Roles.TEACHER },
    children: [
        {
            path: '',
            name: 'TeacherHome',
            component: () => import('@/components/AppDashboard.vue'),
        },
        {
            path: 'dashboard',
            name: 'TeacherDashboard',
            component: () => import('@/views/DashboardView.vue'),
        },
        {
            path: 'tools',
            name: 'TeacherTools',
            component: () => import('@/components/TeacherTools.vue'),
        },
        {
            path: 'content',
            name: 'GeneratedContent',
            component: () => import('@/components/AllLessonContent.vue'),
        },
        { path: 'slides',      name: 'SlidesGenerator',      component: () => import('@/components/SlidesGenerator.vue') },
        { path: 'lesson-plan', name: 'LessonPlanGenerator',  component: () => import('@/components/LessonPlanGenerator.vue') },
        { path: 'full-plan',   name: 'FullPlanGenerator',    component: () => import('@/components/FullLessonGenerator.vue') },
        { path: 'quiz',        name: 'QuizGenerator',        component: () => import('@/components/QuizGenerator.vue') },
    ],
};
